<template>
  <section class="notify">
    <div>
      <h3>{{ title }}</h3>
      <p>{{ message }}</p>
      <ul>
        <li @click="nav('roadside')">Call</li>
        <li @click="toggle">Cancel</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "AlertRoadside",
  props: {
    message: String,
    title: String,
    toggle: Function
  },
  methods: {
    nav(dest) {
      this.$router.push({ path: `${dest}` });
    }
  }
};
</script>

<style lang="scss">
.notify {
  position: absolute;
  top: 30%;
  left: 5%;
  border-radius: 3px;
  width: 90%;
  margin: 0 auto;
  color: #fff;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  display: none;
  padding-top: 1rem;

  img {
    margin: 15px;
  }

  h3 {
    margin: 0;
  }

  p {
    margin: 0 auto;
    width: 70%;
    margin-bottom: 1rem;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    li {
      padding: 0.5rem 0;
      width: 100%;
      border-top: 1px solid darkgrey;
    }

    li:hover {
      background-color: rgb(94, 94, 94);
      cursor: pointer;
    }
  }
  .red {
    color: rgb(171, 0, 0);
  }
  .active & {
    display: block;
  }
}
</style>
